import { USERTENANT } from "@types/usertenant";

export const BlankUserTenantData: USERTENANT = {
  id: 0,
  user_id: "",
  tenant_department_id: 0,
  position_name: "",
};
